<template>
  <div ref="cursorIndicator" class="cursor-indicator">
    <svg
      width="161"
      height="160"
      viewBox="0 0 161 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_16_146)">
        <path
          d="M102.07 156.42H102.06L95.0703 157.71L88.0703 141.45L87.5703 141.54L90.71 158.52L87.0898 159.19L83.4902 139.71L90.4805 138.42L97.4902 154.68L97.9902 154.59L94.8496 137.61L98.4697 136.94L102.07 156.42ZM47.1602 138.31C48.9302 134.02 52.5705 132.46 57.0703 134.32C61.6201 136.2 63.3699 139.981 61.4199 144.69V144.71L59.6104 149.1C57.6704 153.81 53.76 155.26 49.21 153.38C44.71 151.52 43.23 147.85 45 143.56L45.0596 143.4L48.46 144.8L48.3496 145.06C47.4696 147.2 48.0205 149.27 50.4805 150.28C52.9403 151.29 55.0699 150.28 56.1299 147.71L57.9902 143.21C59.0501 140.65 58.25 138.42 55.79 137.41C53.33 136.4 51.4796 137.47 50.5996 139.61L50.4102 140.08L47.0098 138.68L47.1602 138.31ZM106.76 132.58C111.21 130.33 115.31 131.43 117.61 135.98L119.75 140.23C122.05 144.78 120.49 148.731 116.04 150.98C111.59 153.23 107.49 152.13 105.19 147.58L103.05 143.33C100.75 138.78 102.31 134.83 106.76 132.58ZM75.8701 142.32C78.13 142.47 79.8197 144.36 79.6797 146.65C79.5295 148.94 77.6995 150.61 75.3496 150.46C72.9998 150.31 71.39 148.48 71.54 146.13C71.6901 143.73 73.6702 142.18 75.8701 142.32ZM114.23 137.56C113.011 135.13 110.75 134.31 108.271 135.56C105.791 136.81 105.12 139.12 106.34 141.54L108.59 145.99C109.81 148.42 112.07 149.24 114.55 147.99C117.03 146.74 117.7 144.43 116.48 142.01L114.23 137.56ZM31.8398 127.3C34.9998 123.3 39.2404 123.05 43.1504 126.14C47.0603 129.23 47.7899 133.41 44.6299 137.41L41.6797 141.14C38.5197 145.14 34.2801 145.39 30.3701 142.3C26.4602 139.21 25.73 135.03 28.8896 131.03L31.8398 127.3ZM41.0801 128.76C38.9101 127.04 36.5298 127.4 34.8398 129.53L31.75 133.44C30.0702 135.57 30.2705 137.97 32.4404 139.69C34.6103 141.41 36.9898 141.05 38.6797 138.92L41.7695 135.01C43.4495 132.88 43.2501 130.48 41.0801 128.76ZM120.55 122.95C124.19 119.55 128.44 119.46 131.92 123.19L135.16 126.67C138.63 130.4 138.25 134.63 134.6 138.03C130.95 141.43 126.71 141.52 123.23 137.79L119.99 134.31C116.52 130.58 116.9 126.35 120.55 122.95ZM129.11 125.66C127.26 123.67 124.86 123.51 122.83 125.4C120.8 127.29 120.8 129.69 122.65 131.68L126.05 135.32C127.9 137.31 130.3 137.47 132.33 135.58C134.36 133.69 134.36 131.29 132.51 129.3L129.11 125.66ZM25.96 106.19L11.6602 115.5L11.9404 115.93L28.0898 109.46L31.46 114.63L19.0098 126.79L19.29 127.22L33.5898 117.91L35.5703 120.95L18.9697 131.76L18.9502 131.75L15.1699 125.94L27.7695 113.65L27.4902 113.22L11.1602 119.771L7.37988 113.96L23.9805 103.15L25.96 106.19ZM130.59 110.77C133 106.87 136.84 105.49 140.5 107.74L141.17 108.16L139.24 111.29L138.57 110.87C136.55 109.62 134.72 110.32 133.38 112.49C132.04 114.66 132.34 116.33 133.69 117.17C135.09 118.03 136.331 117.1 138.15 115.23L138.61 114.75C141.54 111.73 143.98 110.421 147.06 112.32C150.14 114.22 150.53 117.69 148.3 121.3C146.07 124.91 142.62 126.41 138.96 124.15L138.24 123.7L140.17 120.57L140.89 121.02C142.82 122.21 144.31 121.5 145.5 119.58C146.69 117.65 146.47 116.29 145.22 115.51C143.97 114.74 142.789 115.3 141.1 117.06L140.64 117.54C137.66 120.65 134.93 122.26 131.85 120.36C128.77 118.46 128.18 114.669 130.59 110.77ZM24.04 100.94L5.33984 107.47L4.11035 103.94L22.8096 97.4102L24.04 100.94ZM138.68 89.3896C139.4 85.3799 142.76 82.7106 147.77 83.6104L147.76 83.6201L152.44 84.46C157.45 85.3601 159.7 88.8701 158.83 93.71C157.97 98.4999 154.75 100.74 150.41 99.96L150.3 99.9404L150.95 96.3203L151.17 96.3604C153.23 96.7303 155.08 95.74 155.55 93.1201C156.02 90.5001 154.57 88.6296 151.84 88.1396L147.05 87.2803C144.32 86.7903 142.26 88.0302 141.78 90.7002C141.3 93.3701 142.65 94.82 144.82 95.21L145.1 95.2598L145.93 90.6396L149.05 91.2002L147.57 99.4404L137.6 97.6504L138.21 94.25L140.08 94.5801L140.17 94.0801C139.29 93.5201 138.14 92.3896 138.68 89.3896ZM20.5996 87.2803L4.04004 93.5596L4.11035 94.0596L21.21 91.6797L21.7197 95.3203L2.09961 98.0498L1.12012 91.0098L17.6797 84.7305L17.6104 84.2305L0.509766 86.6104L0 82.9697L19.6201 80.2402L20.5996 87.2803ZM159.27 70.9795L142.47 76.5898L142.52 77.0996L159.7 75.4102L160.06 79.0703L140.34 81.0098L139.64 73.9404L156.44 68.3301L156.39 67.8203L139.21 69.5098L138.85 65.8496L158.57 63.9102L159.27 70.9795ZM0.660156 68.2803C1.33016 63.4603 4.46008 61.0902 8.83008 61.7002L8.94043 61.7197L8.42969 65.3604L8.20996 65.3301C6.13998 65.0401 4.32972 66.1103 3.96973 68.7402C3.59987 71.3701 5.12021 73.1903 7.87012 73.5703L12.6904 74.2402C15.4401 74.62 17.4502 73.3 17.8203 70.6104C18.1903 67.9204 16.7896 66.5197 14.5996 66.2197L14.3203 66.1797L13.6699 70.8301L10.5303 70.3896L11.6797 62.0898L21.71 63.4805L21.2402 66.9004L19.3604 66.6396L19.29 67.1396C20.19 67.6596 21.3798 68.7399 20.96 71.7695C20.4 75.8094 17.1502 78.61 12.1104 77.9102L12.1201 77.9199L7.41016 77.2695C2.36024 76.5695 -0.0197266 73.1501 0.660156 68.2803ZM156.8 57.9297L137.85 63.71L136.76 60.1396L155.71 54.3604L156.8 57.9297ZM146.62 35.5L133.55 47.2803L133.81 47.7197L150.39 41.8203L153.94 47.7803L136.92 57.9297L135.06 54.8203L149.72 46.0801L149.46 45.6396L133.06 51.46L129.9 46.1602L142.82 34.5L142.56 34.0596L127.9 42.7998L126.04 39.6904L143.05 29.54H143.07L146.62 35.5ZM10.0703 40.2998C12.1603 36.6 15.5401 34.9701 19.29 37.0801L20.0303 37.5L18.2197 40.71L17.4805 40.29C15.5105 39.18 14.0399 39.9402 12.9199 41.9102C11.81 43.8801 12.0804 45.24 13.3604 45.96C14.6403 46.6798 15.8003 46.0699 17.4102 44.25L17.8496 43.75C20.7096 40.52 23.3705 38.8001 26.5205 40.5801C29.6702 42.3602 30.4101 46.1203 28.1602 50.1201C25.9102 54.12 22.1201 55.65 18.3701 53.54H18.4004L17.71 53.1504L19.5205 49.9404L20.21 50.3301C22.28 51.5001 24.0801 50.7298 25.3301 48.5098C26.58 46.2899 26.2198 44.6196 24.8398 43.8496C23.41 43.0399 22.2098 44.0201 20.46 45.96L20.0205 46.46C17.2205 49.59 14.8299 51.0095 11.6699 49.2295C8.51019 47.4494 7.99038 43.9997 10.0703 40.2998ZM23.0996 23.0303C26.6096 19.4903 30.8497 19.2403 34.4697 22.8203L37.8496 26.1699C41.4696 29.7599 41.2502 34.0001 37.7402 37.54C34.2302 41.08 29.9901 41.33 26.3701 37.75L22.9902 34.4004C19.3704 30.8105 19.59 26.5702 23.0996 23.0303ZM31.7598 25.3896C29.8299 23.48 27.4303 23.4103 25.4805 25.3799C23.5305 27.3499 23.6198 29.7502 25.5498 31.6602L29.0898 35.1699C31.0198 37.0799 33.4201 37.1497 35.3701 35.1797C37.3199 33.2097 37.2297 30.8103 35.2998 28.9004L31.7598 25.3896ZM120.72 19.2705C124.03 15.4006 128.28 15.3101 132.06 18.5498C135.84 21.7898 136.41 26.0001 133.1 29.8701L130.01 33.4805C126.7 37.3501 122.45 37.44 118.67 34.2002C114.89 30.9602 114.32 26.7499 117.63 22.8799L120.72 19.2705ZM129.9 21.0898C127.79 19.2898 125.4 19.5501 123.64 21.6201L120.4 25.4004C118.63 27.4603 118.74 29.8599 120.85 31.6699C122.96 33.4699 125.35 33.2096 127.11 31.1396L130.35 27.3604C132.12 25.3004 132.01 22.8998 129.9 21.0898ZM41.1299 9.36035C45.4798 6.94037 49.6296 7.87018 52.0996 12.3301L54.4102 16.4902C56.88 20.9401 55.4896 24.9602 51.1396 27.3701C46.7898 29.7899 42.6399 28.8601 40.1699 24.4004L37.8604 20.2402C35.3904 15.7903 36.7801 11.7704 41.1299 9.36035ZM103.15 10.5898C105.28 5.9601 109.24 4.67057 113.72 6.73047C118.14 8.77046 119.48 12.5 117.54 16.71L117.47 16.8604L114.13 15.3203L114.25 15.0596C115.22 12.9497 114.75 10.8599 112.33 9.75C109.91 8.64002 107.74 9.56996 106.58 12.0898L104.54 16.5098C103.38 19.0298 104.08 21.2904 106.5 22.4004C108.92 23.5103 110.81 22.5101 111.78 20.4102L111.99 19.9502L115.33 21.4902L115.16 21.8496C113.22 26.0696 109.51 27.4804 105.09 25.4404C100.62 23.3805 99.0203 19.5303 101.16 14.9004V14.9102L103.15 10.5898ZM48.7803 14.0498C47.4603 11.6798 45.17 10.9401 42.75 12.29C40.3301 13.64 39.7398 15.97 41.0596 18.3398L43.4795 22.6904C44.7995 25.0603 47.0899 25.8 49.5098 24.4502C51.9296 23.1003 52.5199 20.7703 51.2002 18.4004L48.7803 14.0498ZM74.0996 19.3301L67.1699 20.9004L59.5195 4.92969L59.0195 5.04004L62.8398 21.8799L59.25 22.6904L54.8701 3.37012L61.7998 1.7998L69.4502 17.7695L69.9502 17.6602L66.1299 0.820312L69.7197 0.00976562L74.0996 19.3301ZM82.9805 12.25C83.2205 9.97004 85.12 8.37013 87.46 8.62012C89.7998 8.8701 91.3396 10.7598 91.0898 13.0996C90.8399 15.4895 88.8102 16.9602 86.6104 16.7305C84.3604 16.5005 82.7405 14.53 82.9805 12.25Z"
          fill="white"
          style="fill: white; fill-opacity: 1"
        />
      </g>
      <defs>
        <clipPath id="clip0_16_146">
          <rect
            width="160.06"
            height="159.18"
            fill="white"
            style="fill: white; fill-opacity: 1"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, defineExpose } from "vue";
import { gsap } from "gsap";

const cursorIndicator = ref(null);

// Cursor indicator variables
let isHoveringWip = false;
let cursorX = 0;
let cursorY = 0;
let indicatorX = 0;
let indicatorY = 0;
let animationId = null;
let hasUserMovedMouse = false;
let hideAnimation = null; // Track hide animation
let bounceAnimation = null; // Track bounce animation
let isClickDisabled = false; // Prevent rapid clicking

// Mobile detection
const isMobileDevice = () => {
  // Check for touch capability and screen size
  const hasTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;
  const isSmallScreen = window.innerWidth <= 640; // 40rem = 640px
  return hasTouch && isSmallScreen;
};

// Cursor tracking with inertia
const handleMouseMove = (e) => {
  cursorX = e.clientX;
  cursorY = e.clientY;

  // Mark that the user has moved their mouse
  if (!hasUserMovedMouse) {
    hasUserMovedMouse = true;
  }
};

// Animate cursor indicator with inertia
const animateCursorIndicator = () => {
  if (isHoveringWip && cursorIndicator.value) {
    // Calculate the distance and apply easing for inertia
    const deltaX = cursorX - indicatorX;
    const deltaY = cursorY - indicatorY;

    // Apply inertia by reducing the movement by a factor (0.15 = slower, more inertia)
    indicatorX += deltaX * 0.1;
    indicatorY += deltaY * 0.1;

    // Apply the position with GSAP for smooth rendering
    gsap.set(cursorIndicator.value, {
      x: indicatorX,
      y: indicatorY,
    });

    // Add slight rotation based on movement direction for extra flair
    const rotationAmount = deltaX * 0.02; // Subtle rotation based on horizontal movement
    gsap.set(cursorIndicator.value, {
      rotation: -20 + rotationAmount,
    });
  }

  if (isHoveringWip) {
    animationId = requestAnimationFrame(animateCursorIndicator);
  }
};

// Setup cursor indicator functionality
const setupCursorIndicator = () => {
  if (!cursorIndicator.value) return;

  // Don't setup cursor indicator on mobile devices
  if (isMobileDevice()) {
    return;
  }

  // Initially hide and position the cursor indicator completely off-screen
  gsap.set(cursorIndicator.value, {
    scale: 0,
    opacity: 0,
    x: -9999, // Move far off-screen initially
    y: -9999,
    xPercent: -50,
    yPercent: -50,
    rotation: -20,
    visibility: "hidden", // Ensure it's completely hidden
  });

  // Add event listeners to all .wip projects
  const wipProjects = document.querySelectorAll(".proj.wip");

  wipProjects.forEach((project) => {
    project.addEventListener("mouseenter", () => {
      // Only show indicator if user has moved mouse (not during page load)
      if (!hasUserMovedMouse) return;

      const wasAlreadyHovering = isHoveringWip;
      isHoveringWip = true;

      // Cancel any ongoing hide animation
      if (hideAnimation) {
        hideAnimation.kill();
        hideAnimation = null;
      }

      // Only reset position if we weren't already hovering a .wip item
      if (!wasAlreadyHovering) {
        // Initialize indicator position to current cursor position
        indicatorX = cursorX;
        indicatorY = cursorY;

        // Make visible and position indicator at current cursor position
        gsap.set(cursorIndicator.value, {
          visibility: "visible",
          x: indicatorX,
          y: indicatorY,
        });

        // Animate in
        gsap.to(cursorIndicator.value, {
          scale: 1,
          opacity: 1,
          duration: 0.3,
          ease: "back.out(1.7)",
        });

        // Start the inertia animation loop
        animateCursorIndicator();
      }
      // If we were already hovering, resume animation smoothly
      else {
        gsap.set(cursorIndicator.value, {
          visibility: "visible",
        });

        // Resume scale and opacity smoothly
        gsap.to(cursorIndicator.value, {
          scale: 1,
          opacity: 1,
          duration: 0.15,
          ease: "power2.out",
        });

        // Ensure inertia animation is running
        if (!animationId) {
          animateCursorIndicator();
        }
      }
    });

    project.addEventListener("mouseleave", () => {
      // Start scaling down immediately but don't stop inertia yet
      gsap.to(cursorIndicator.value, {
        scale: 0.7,
        opacity: 0.6,
        duration: 0.1,
        ease: "power2.in",
      });

      // Wait a bit to see if we enter another .wip
      setTimeout(() => {
        // Check if we're still not hovering any .wip after a short delay
        const stillHoveringWip = document.querySelector(".proj.wip:hover");
        if (!stillHoveringWip) {
          isHoveringWip = false;

          // Cancel the animation loop
          if (animationId) {
            cancelAnimationFrame(animationId);
            animationId = null;
          }

          // Complete the hide animation
          hideAnimation = gsap.to(cursorIndicator.value, {
            scale: 0,
            opacity: 0,
            duration: 0.15,
            ease: "power2.in",
            onComplete: () => {
              // Only hide if we're still not hovering
              if (!isHoveringWip) {
                gsap.set(cursorIndicator.value, {
                  visibility: "hidden",
                  x: -9999,
                  y: -9999,
                });
              }
              hideAnimation = null;
            },
          });
        }
      }, 50); // Small delay to allow for quick transitions between .wip items
    });

    // Add click bounce animation
    project.addEventListener("click", (e) => {
      // Only animate if the cursor indicator is visible and clicking is not disabled
      if (isHoveringWip && cursorIndicator.value && !isClickDisabled) {
        // Prevent default link behavior temporarily to show animation
        e.preventDefault();

        // Disable clicking temporarily
        isClickDisabled = true;

        // Kill any existing bounce animation
        if (bounceAnimation) {
          bounceAnimation.kill();
          bounceAnimation = null;
        }

        // Reset scale to ensure we start from the correct size
        gsap.set(cursorIndicator.value, { scale: 1 });

        // Bounce animation
        bounceAnimation = gsap.to(cursorIndicator.value, {
          scale: 1.3,
          duration: 0.1,
          ease: "power2.out",
          yoyo: true,
          repeat: 1,
          onComplete: () => {
            bounceAnimation = null;

            // Re-enable clicking after a short delay
            setTimeout(() => {
              isClickDisabled = false;
            }, 50);

            // After bounce, proceed with the original link if it exists
            const link = project.querySelector("a");
            if (link) {
              // Small delay to let user see the bounce
              setTimeout(() => {
                link.click();
              }, 50);
            }
          },
        });
      }
    });
  });

  // Add global mouse move listener
  document.addEventListener("mousemove", handleMouseMove);
};

// Cleanup cursor indicator
const cleanupCursorIndicator = () => {
  isHoveringWip = false;

  // Cancel any running animation frame
  if (animationId) {
    cancelAnimationFrame(animationId);
    animationId = null;
  }

  // Cancel any ongoing animations
  if (hideAnimation) {
    hideAnimation.kill();
    hideAnimation = null;
  }

  if (bounceAnimation) {
    bounceAnimation.kill();
    bounceAnimation = null;
  }

  // Hide the cursor indicator
  if (cursorIndicator.value) {
    gsap.set(cursorIndicator.value, {
      scale: 0,
      opacity: 0,
      visibility: "hidden",
      x: -9999,
      y: -9999,
    });
  }
};

// Expose setup and cleanup functions
const initializeCursor = () => {
  setupCursorIndicator();
};

const destroyCursor = () => {
  document.removeEventListener("mousemove", handleMouseMove);
  cleanupCursorIndicator();
};

onMounted(() => {
  // Initialize after a short delay to ensure DOM is ready
  setTimeout(() => {
    initializeCursor();
  }, 100);
});

onUnmounted(() => {
  destroyCursor();
});

// Expose methods for external control
defineExpose({
  initializeCursor,
  destroyCursor,
});
</script>

<style scoped lang="scss">
.cursor-indicator {
  position: fixed;
  top: 0;
  left: 0;
  width: 120px;
  height: 120px;
  background-color: rgba(0, 0, 0, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 9999;
  transform: translate(-50%, -50%);
  visibility: hidden;
  opacity: 0;

  svg {
    width: 75%;
    height: 75%;
    animation: slowRotate 8s linear infinite;
  }
}

@keyframes slowRotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
